import { useEffect, useRef, useState } from 'react'

import { FacetedCategoryDto } from 'types/dtos/catalog'

import { generateNavStack } from './utils'

const useNavStack = (
  categories: Array<FacetedCategoryDto> | undefined,
  catalogIds: Array<number>,
) => {
  const [navStack, setNavStack] = useState<Array<number>>([])

  const navStackRef = useRef(navStack)
  navStackRef.current = navStack

  const initialNavStackSet = useRef(false)

  // make sure navigation stack is always valid for the categories
  useEffect(() => {
    if (!categories) return

    let cats: Array<FacetedCategoryDto> | undefined = categories
    let foundCount = 0

    while (cats) {
      const target = navStackRef.current[foundCount]
      cats = cats.find(cat => Number(cat.id) === target)?.categories
      foundCount += 1
    }

    setNavStack(prev => prev.slice(0, foundCount - 1))
  }, [categories])

  // on initial mount, initialize the nav stack to the selected category
  useEffect(() => {
    if (!categories) return

    const targetId = catalogIds[0]
    if (!targetId) return

    if (initialNavStackSet.current) return
    initialNavStackSet.current = true

    const initialNavStack = generateNavStack(categories, targetId)
    if (initialNavStack) setNavStack(initialNavStack)
  }, [catalogIds, categories])

  return [navStack, setNavStack] as const
}

export default useNavStack
